export const TEXT_FEATURE_KEY = 'text';
